<div class="container">
    <div class="row g-3">
        <div class="col-xl-8 col-lg-8 col-md-6 col-12">
            <div class="d-flex">
                <h2 class="m-0">
                    สมาชิก
                </h2>
                <button class="btn btn-primary ms-md-2 ms-auto" (click)="addMember()">เพิ่มสมาชิก</button>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-12 text-md-end">
            <!-- <div class="input-icon-start">
                <input type="text" class="form-control" placeholder="ค้นหาสมาชิก" (change)="getMember(filter,1)" #filter>
                <span class="material-symbols-outlined">
                    search
                </span>
            </div> -->

            <app-filter [text]="'ค้นหาสมาชิก'" (updateValue)="getMember($event)"></app-filter>
        </div>
    </div>
    <br>
    <div class="row g-3">
        <div class="col-12">
            <table class="table align-middle">
                <thead>
                    <tr>
                        <th>RANK</th>
                        <th class="d-none d-xl-table-cell d-lg-table-cell  d-md-table-cell">ระดับ RANK</th>
                        <th>ชื่อ-นามสกุล</th>
                        <th>เบอร์โทรศัพท์</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let mb of memberItems">
                        <td><img width="40px" [src]="mb.Rank_image" alt=""></td>
                        <td class="d-none d-xl-table-cell d-lg-table-cell   d-md-table-cell">{{mb.Rank_name}}</td>
                        <td>{{mb.Member_name}}</td>
                        <td>+{{mb.Member_tel_code}}{{mb.Member_tel}}</td>
                        <td>
                            <!-- <button class="btn btn-primary w-100" (click)="viewMember(mb)">ดูข้อมูลเพิ่มเติม</button> -->
                        </td>
                    </tr>
                </tbody>
            </table>
            <app-pagination *ngIf="memberItems" [page]="1" [pageTotal]="pageTotal"
                (updatePage)="getMember($event)"></app-pagination>
        </div>
    </div>
</div>


<p-dialog [header]="message" [(visible)]="manageMember" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '50vw' }" [draggable]="false"
    [resizable]="false" (onHide)="clearEvent()">
    <div class="row g-3" [formGroup]="formMember">
        <div class="col-12">
            <label>ชื่อ - นามสกุล</label>
            <input type="text" class="form-control" formControlName="Fullname" required placeholder="ชื่อ - นามสกุล">
            <br>
            <label>เบอร์โทรศัพท์</label>
            <input type="text" class="form-control" formControlName="Tel" required placeholder="เบอร์โทรศัพท์">
            <br>
        </div>
        <div class="col-12 text-end">
            <button type="submit" class="btn btn-primary" (click)="createMember()">สร้างสมาชิก</button>
        </div>
    </div>
</p-dialog>